<template>
  <el-col :span="normalizedSpan">
    <el-form-item :prop="name" :label="label" :label-width="labelWidth" :required="required" :rules="normalizedRules">
      <OFileInput v-model="model" :disabled="normalizedDisabled" @change="(attrs.onChange)" />
    </el-form-item>
  </el-col>
</template>

<script setup lang="ts">
import { ElCol, ElFormItem } from 'element-plus'
import type { FormFileInputProps } from './FileInput'
import OFileInput from '../../Input/FileInput/FileInput.vue'
import { useFormItemSpan, useFormItemRules, useFormItemModel, useFormItemDisabled } from '../hooks'
import { useAttrs } from 'vue'

defineOptions({ name: 'OFormFile', inheritAttrs: false })
const attrs = useAttrs()

const { name, label, labelWidth, required, disabled } = defineProps<FormFileInputProps>()
const normalizedSpan = useFormItemSpan()
const normalizedRules = useFormItemRules()
const normalizedDisabled = useFormItemDisabled()
const model = useFormItemModel()
</script>
